"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// Makes sure the end is within the bounds of the creative timeline.
// All values are in seconds
var getClampedEndTime = function getClampedEndTime(startTime, endTime, elementStartTime, globalEndTime) {
  // How long the clip WANTS to be.
  var desiredDuration = endTime - startTime; // The longest a clip can be is from its appearance in the timeline to the end of the timeline.

  var maxDuration = globalEndTime - elementStartTime; // Clamp (aka limit) the duration of the clip.

  var clampedDuration = Math.min(maxDuration, desiredDuration);
  return startTime + clampedDuration;
};

var _default = getClampedEndTime;
exports["default"] = _default;